<template>
  <div
    v-loading="loading"
    class="table-layout-wrap"
  >
    <slot name="upActions" />

    <div v-if="!noActions" class="table-actions flex-actions">
      <el-tooltip v-if="expandAll" :content="expand ? '关闭' : '展开'" placement="top">
        <div class="expand-all-icon icon-btn main-btn" :class="{active: expand}" @click="expandAllRows(!expand)">
          <div />
        </div>
      </el-tooltip>

      <div class="actions-box">
        <div>
          <slot name="leftActions" />
        </div>
        <div class="sz-rightActions-box">
          <slot name="rightActions" />
          <el-button
            v-if="rightActions.update"
            class="inline-btn"
            icon="el-icon-refresh"
            :underline="false"
            type="text"
            @click="getData"
            title="刷新"
          />
          <div v-if="rightActions.exportInfo && rightActions.exportInfo.isHide !== true">
            <el-button
              class="inline-btn"
              icon="el-icon-download"
              :underline="false"
              type="text"
              @click="rightActions.exportInfo.exportFnc"
              title="导出"
            />
          </div>
          <a v-if="rightActions.linkInfo" :href="rightActions.linkInfo.path" target="_blank" >
            <el-button
              class="inline-btn"
              icon="el-icon-link"
              :underline="false"
              type="text"
              title="链接"/>
          </a>
          <vxe-switch
            v-if="rightActions.switchInfo"
            v-model="rightActions.switchInfo.value"
            :open-label="rightActions.switchInfo.openLabel"
            :open-value="1"
            :close-label="rightActions.switchInfo.closeLabel"
            :close-value="0"
          />
          <slot
            name="rightActionsRight"
          />
        </div>
      </div>

      <span
        v-if="false"
        class="selection"
      >
        已选{{ 1 }}条
      </span>
    </div>

    <slot name="downActions" />

    <div style="flex: 1;overflow: hidden">
      <vxe-table
        @checkbox-all="checkboxAll"
        @checkbox-change="checkboxChange"
        ref="mainTable"
        :data="tableData"
        :border="border"
        :show-header-overflow="showHeaderOverflow"
        :empty-render="{name: 'NotData-big'}"
        height="auto"
        :row-style="{ height: `${rowHeight}px` }"
        :row-class-name="rowClassName"
        :show-footer="showSummary"
        :footer-method="summaryMethod"
        :tree-config="treeProps"
        :span-method="spanMethod"
        :sort-config="sortConfig"
        :edit-config='editConfig'
        :checkbox-config="checkboxConfig"
        @sort-change="sortChange"
      >
        <slot name="tableColumn" />
      </vxe-table>
    </div>

    <div v-show="page.total >= 0" class="table-actions">
      <PageBtn
        class="bottom-page"
        :page="page"
        @page-change="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import isObject from 'lodash/isObject'
import PageBtn from './page-btn'
export default {
  name: 'CardTable',
  components: {
    PageBtn
  },
  props: {
    checkboxAll: { // 临时
      type: Function,
      default: () => {}
    },
    checkboxChange: { // 临时
      type: Function,
      default: () => {}
    },
    initFuc: {
      type: Function,
      default: null
    },
    getTableData: {
      type: Function,
      required: true
    },
    pageSizes: {
      type: Array,
      default: undefined
    },
    page: {
      type: Object,
      default: () => {
        return {
          currentPage: 1,
          total: 0,
          pageSize: 50,
          pageSizes: [50, 100, 200]
        }
      }
    },
    showSummary: {
      type: Boolean,
      default: false
    },
    noActions: {
      type: Boolean,
      default: false
    },
    summaryMethod: { // 尾部
      type: Function,
      default: null
    },
    treeProps: { // 下拉项
      type: Object,
      default: null
    },
    rowHeight: {
      type: Number,
      default: 80
    },
    showHeaderOverflow: {
      type: Boolean,
      default: true

    },
    rowClassName: {
      default: null
    },
    expandAll: {
      type: Boolean,
      default: false
    },
    sortConfig: { // 排序配置
      type: Object,
      default: null
    },
    editConfig: { // 列表编辑配置
      type: Object,
      default: null
    },
    rightActions: { // 自定义头部
      type: Object,
      default() {
        return {}
      }
    },
    spanMethod: { // 合并单元格方法
      type: Function,
      default: null
    },
    sortChange: { // 排序选择
      type: Function,
      default: () => {}
    },
    border: {
      type: [String, Boolean],
      default: false
    },
    checkboxConfig: {
      type: Object,
      default: null
    },
    formConfig: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],

      expand: false
    }
  },
  created() {
    this.mergePagination()
    const { setHeader } = this.rightActions
    if (setHeader) {
      setHeader.editHeaderList = setHeader.defaultHeaderList
    }
  },
  async mounted() {
    this.mainTable = this.$refs.mainTable
    if (this.initFuc) await this.initFuc()
    await this.initDefaultFormConfigFromQuery()

    this.getData()
  },
  methods: {
    // 从query回填formConfig
    initDefaultFormConfigFromQuery() {
      try {
        const { defaultFormConfig } = this.$route.query
        if (!defaultFormConfig) {
          return
        }

        const config = JSON.parse(defaultFormConfig)
        console.log('===initDefaultFormConfigFromQuery config', config)

        if (isObject(config)) {
          Object.entries(config).forEach(([key, item]) => {
            if (this.formConfig[key]) {
              // assign value
              if (item.value !== undefined) {
                this.formConfig[key].value = item.value
              }
              // assign selectValue
              if (item.selectValue !== undefined) {
                this.formConfig[key].selectValue = item.selectValue
              }
            }
          })
        }
      } catch (err) {

      }
    },
    // 全部展开
    expandAllRows(expand) {
    },
    onPageChange() {
      this.$nextTick(() => {
        this.getData()
      })
    },
    reset() {
      this.page.currentPage = 1
      this.expand = false
      this.$nextTick(() => {
        this.getData()
      })
    },
    async getData() {
      try {
        this.loading = true
        const { currentPage, pageSize } = this.page
        const res = await this.getTableData(currentPage, pageSize)
        if (!res) {
          this.loading = false
          return
        }
        const { tableData, total } = res
        this.tableData = tableData
        this.page.total = total
      } finally {
        this.loading = false
      }
    },

    // 合并 page config
    mergePagination() {
      const { page, pageSizes } = this
      Array.isArray(pageSizes) && pageSizes.length > 0 && (page.pageSizes = pageSizes)
    },

    getIndex(index) {
      const { pageSize, currentPage } = this.page
      return pageSize * (currentPage - 1) + index + 1
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep .table-actions{
  min-height: 16px;
}
::v-deep .table-actions > * {
  vertical-align: middle;
}

.expand-all-icon{
  width: 32px;
  height: 32px;
  padding: 5px;
  background: linear-gradient(360deg, #F6F6F6 0%, #FCFCFC 100%);
  border-radius: 4px;
  border: 1px solid #D9D9D9;
  color: rgba(96, 98, 102, 1);
  div {
    background: url('~@/icons/png/expand.png') center center no-repeat;
    height: 100%;
    background-size: contain;
  }
  &:hover {
    border: 1px solid rgba(130, 97, 247, 0.3);
    div {
      background: url('~@/icons/png/expand-hover.png') center center no-repeat;
      background-size: contain;
    }
  }
  &:active, &.active {
    background: rgba(130, 97, 247, 1);
    border: 1px solid rgba(130, 97, 247, 1);
    div {
      background: url('~@/icons/png/expand-active.png') center center no-repeat;
      background-size: contain;
    }
  }
  &.active:hover {
    background: rgba(130, 97, 247, 0.8);
    border: 1px solid rgba(130, 97, 247, 0);
  }
}

.icon-btn {
  display: inline-block;
  margin-right: 4px;
}

.sort-btn {
  float: right
}
::v-deep .frozen-row{
  background:#eee !important;
  .order-msg-view, .text {
    color: #9D9C9E
  }
}
.bottom-page{
  margin-bottom: 0;
}
.actions-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sz-rightActions-box{
  display: flex;
  .inline-btn {
    margin-left: 12px;
    font-size: 14px;
    line-height: 32px;
    padding: 0 8px;
    border-color: #d9d9d9;
    color: #9D9C9E;
  }
  .inline-btn:hover{
    color: $main-color;
    border-color: $main-color;
  }
}
</style>
<style scoped lang="scss">
.table-layout-wrap {
  display: flex;
  flex-direction:column;
  flex: 1;
  overflow: hidden;

  .table-actions{

    > .title {
      height: 52px;
      line-height: 52px;
    }

    & > * {
      height: 32px;
      line-height: 32px;
      margin-top: 12px;
      margin-bottom: 12px;
    }

    .el-button {
      //padding: 6px 20px 6px 0;
      // padding:7px 12px;
      height:32px;
    }
    .second-btn{
      vertical-align: top;
    }
    .el-popover__reference-wrapper{.second-btn{
      vertical-align: initial;
    }}
    .el-dropdown{
      .el-button--small{
      padding:7px 8px 7px 12px;
      &.d-mar{
        padding:7px 12px;
      }
      }}

  }

  .page {
    float: right;
    padding: 0;
  }

  .table-wrap {
    flex: 1 1 auto;
    overflow: hidden;
  }

  .selection {
    font-size: 12px;
    color: #606266;
    float: right;
    padding-right: 20px;

    span {
      color: $main-color;
      padding: 0 4px;
    }
  }

  .action-btn {
    padding: 0;
  }

}

</style>
